import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";

const IndicatorContainer = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 30;
  pointer-events: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 40px;

  cursor: pointer;

  transition: all 0.3s ease;

  &:active {
    transform: translateY(-50%) scale(0.95);
  }
`;

const LeftIndicator = styled(IndicatorContainer)`
  left: 0px;
  align-items: flex-end;
`;

const RightIndicator = styled(IndicatorContainer)`
  right: 0px;
  align-items: flex-start;
`;

const ChevronIcon = styled(motion.div)`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.8);
  font-size: 2rem;
  font-weight: bold;
  text-shadow:
    0 0 10px rgba(0, 255, 0, 0.5),
    0 0 20px rgba(0, 255, 0, 0.3),
    2px 0 #00ff00;
  background: rgba(0, 255, 0, 0.1);
  border-radius: 50%;
  border: 2px solid rgba(0, 255, 0, 0.3);

  &::before {
    content: "${props => (props.direction === "left" ? "‹" : "›")}";
  }

  @media (max-width: 480px) {
    width: 36px;
    height: 36px;
    font-size: 1.75rem;
  }

  @media (max-width: 360px) {
    width: 32px;
    height: 32px;
    font-size: 1.5rem;
  }
`;

const SwipeIndicators = ({ isActive, onLeftClick, onRightClick }) => {
  const indicatorVariants = {
    idle: {
      opacity: 0.6,
      scale: 1,
      color: "rgba(255, 255, 255, 0.8)",
    },
    active: {
      opacity: 1,
      scale: 1.15,
      color: "rgba(0, 255, 0, 1)",
    },
    pulse: {
      opacity: [0.6, 1, 0.6],
      scale: [1, 1.1, 1],
      color: [
        "rgba(255, 255, 255, 0.8)",
        "rgba(0, 255, 0, 1)",
        "rgba(255, 255, 255, 0.8)",
      ],
    },
  };

  const pulseTransition = {
    duration: 1.5,
    repeat: Infinity,
    ease: "easeInOut",
  };

  return (
    <>
      <LeftIndicator onClick={onLeftClick}>
        <ChevronIcon
          direction="left"
          variants={indicatorVariants}
          initial="idle"
          animate={isActive ? "active" : "pulse"}
          transition={isActive ? { duration: 0.2 } : pulseTransition}
        />
      </LeftIndicator>

      <RightIndicator onClick={onRightClick}>
        <ChevronIcon
          direction="right"
          variants={indicatorVariants}
          initial="idle"
          animate={isActive ? "active" : "pulse"}
          transition={isActive ? { duration: 0.2 } : pulseTransition}
        />
      </RightIndicator>
    </>
  );
};

export default SwipeIndicators;
